import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-entry nav-entry__cart"
};
const _hoisted_2 = { class: "dropdown" };
const _hoisted_3 = {
    class: "d-flex dropdown-toggle",
    style: { "cursor": "pointer" },
    id: "dropdownMenuButton2",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_4 = {
    key: 0,
    class: "d-none d-md-flex caption",
    style: { "padding-left": "20px" }
};
const _hoisted_5 = { class: "text-muted" };
const _hoisted_6 = { class: "text" };
const _hoisted_7 = { class: "icon-container" };
const _hoisted_8 = ["title"];
const _hoisted_9 = {
    key: 0,
    class: "notify-badge"
};
const _hoisted_10 = {
    class: "dropdown-menu dropdown-menu-end mt-2 pt-0 pb-0 shadow",
    style: { "width": "400px" },
    "aria-labelledby": "dropdownMenuButton2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_minicart = _resolveComponent("g-minicart");
    return (_ctx.$appHost.session?.features?.carts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.$store.getters['carts/hasCart'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('client.Commerce.Carts.Cart')), 1),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$store.getters['carts/cartTitle']), 1)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                            class: "icon",
                            title: _ctx.$t('client.Commerce.Carts.Cart')
                        }, [
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "content" }, [
                                _createElementVNode("i", { class: "bi bi-bag-fill fs-icon" })
                            ], -1)),
                            (_ctx.$store.getters['carts/totalLines'] > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$store.getters['carts/totalLines']), 1))
                                : _createCommentVNode("", true)
                        ], 8, _hoisted_8)
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_g_minicart)
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
